import React, { FC } from 'react';

interface BikuporProps {
  onRequestDetails: () => void; // passed from Carousel
}

const Bikupor: FC<BikuporProps> = ({ onRequestDetails }) => {
  return (
    <div className="slide-item-inner">
      <h2 className="slide-item-title title">Våra bigårdar</h2>
      <p className="text-lg text-green-dark/100">
           Vi placerar våra bikupor i noggrant utvalda natursköna områden utanför Örsundsbro, för att säkerställa binas behov av mat, skydd och tillsyn.
      </p>
      <div
        className="slide-item-learnmore button"
        onClick={onRequestDetails} // 👈 trigger detail view
      >
        LÄS MER
      </div>

      {/* New container for the image */}
      <div className="image-container">
        <img
          className="slide-item-background"
          src="/pictures/honeypictures/bikupor/bikupor2rounded.webp"
          draggable="false"
          loading="lazy"
          alt="Bikupor"
        />
      </div>
    </div>
    
  );
};

export default Bikupor;
